<!--美食部分-抵扣券/优惠券详情-->
<template>
    <section id="discountDetails">
        <!--轮播图展示-->
        <v-swipe v-bind:swipes="lunbos"></v-swipe>
        <!--商家信息-->
        <div class="voucherInfo">
            <div class="top">
                <h3>{{initData.name}}</h3>
                <p>{{initData.subName}}</p>
            </div>
                <p class="bottom"><span class="fl">{{initData.tag | filteTag}}</span> <span class="fr">已售{{initData.qtySale}}</span></p>
        </div>
        <!--地图号码模块-->
        <v-mapInfo2 v-bind:mapinfoData2="mapinfoData2"></v-mapInfo2>
        <!--详情-->
        <div class="details">
            <h3>详情</h3>
            <ul>
                <li v-for="(itme, n) in initData.goodsDetails" :key="n">
                    <p>
                        <span>{{itme.name}}</span>
                        <span>{{itme.qty}}</span>
                        <span class="fr">{{itme.amt+itme.unit}}</span>
                    </p>
                </li>
            </ul>
        </div>
        <!--使用须知-->
        <div class="notice">
            <h3>使用须知</h3>
            <dl>
                <dt>有效期</dt>
                <dd>{{initData.validStartTime | dateFormat("YYYY.MM.DD")}} 至 {{initData.validEndTime| dateFormat("YYYY.MM.DD")}} {{initData.remark}}</dd>

                <dt>使用时间</dt>
                <dd>{{initData.onlineStartTime+'-'+initData.onlineEndTime}}</dd>

                <dt>使用说明</dt>
                <dd>
                    <ul v-if="initData.useExplain">
                        <li v-html="initData.useExplain.replace(/\r\n/g,'<br/>')"></li>
                    </ul>
                </dd>
            </dl>
        </div>

        <!--评论模块-->
        <v-comment v-bind:idobj="idobj"></v-comment>
        <!--领取部分-->
        <i></i>
        <div class="gain">
            <span>￥{{initData.price/100}}</span>
            <s>￥{{initData.priceOrigin/100}}</s>
            <a href="" @click.prevent="getDownURL(params)" v-if="goodsType == 2">免费领取</a>
            <a href="" @click.prevent="getDownURL(params)" v-else-if="goodsType == 3">立即抢购</a>
        </div>
    </section>
</template>

<script>
    import {getDownURL} from "../../common/api.config";
    import { fetchVolumeDetail} from '../../common/api/homePage';

    export default {
        name: 'discountDetails',
        data() {
            return {
                goodsType:'',
                idobj:'',
                lunbos: [],
                initData:{},
                mapinfoData2:{},
                obj:{  longitude:0,
                       latitude:0},
                cmd: {
                    "cmd": "C0070004",  // 优惠券详情
                    "url": "",
                    "params": '',
                    "h5Params": "{}",
                    "events": []
                }
            };
        },
        computed: {
            params () {
                this.cmd.params = JSON.stringify({'shopGoodsId': this.id})
                return this.cmd
            },
            id () {
                return this.$route.params.id
            }
        },
        created() {
            this.goodsType =this.$route.params.goodsType;
            this.getData(this.obj);
            this. getLocation()
        },
        watch:{
            obj(curVal){
                fetchVolumeDetail(this.id,curVal).then(rep=>{
                    if(rep.data.code == 0){
                        let data = rep.data.data.goods;
//                        更新距离
                        this.mapinfoData2.distance= data.distance;
                    }
                });
            }
        },
        methods: {
            getDownURL,
//            定位
            getLocation(){
                if (navigator.geolocation){
                    var getOptions = {
                        //是否使用高精度设备，如GPS。默认是true
                        enableHighAccuracy:true,
                        //超时时间，单位毫秒，默认为0
                        timeout:60000,
                        //使用设置时间内的缓存数据，单位毫秒
                        //默认为0，即始终请求新数据
                        //如设为Infinity，则始终使用缓存数据
                        maximumAge:0};
                    navigator.geolocation.getCurrentPosition(this.showPosition,this.showError,getOptions);
                }
            },
            showPosition(position){
                let obj = {
                    latitude:position.coords.latitude,//纬度
                    longitude:position.coords.longitude//经度
                }
                this.obj = obj;
            },
            showError(){
            },
            filtertep(val1,val2){
                var arr = [];
                if(val1||val2){
                    if(val1){
                        arr[0] = {name:val1,method(){window.location.href = "tel:"+val1;}} ;
                    }else {
                        arr[0] = {name:val2,method(){window.location.href = "tel:"+val2;}} ;
                    }

                }
                if(val2&&val1){
                    arr[1] = {name:val2,method(){window.location.href = "tel:"+val2;}} ;
                }
                return arr
            },
            getData(obj) {
                fetchVolumeDetail(this.id,obj).then(rep=>{
                    if(rep.data.code == 0){
                        let data = rep.data.data.goods;
                        this.lunbos = data.picUrls;
                        this.initData = data;
                        this.idobj = {
                            id:this.id,
                            type:'goodsId'
                        }
                        this.mapinfoData2={
                            title:data.name,
                            startNum:data.avgPoint,
                            name:data.shopName,
                            map:data.address,
                            distance:data.distance,
                            actions:this.filtertep(data.tel,data.phone),
                            shopAddr:{longitude:data.longitude,latitude:data.latitude},
                        }
                    }
                });
            }
        },
        filters:{
            filteTag(val){
                var arr = ['','无门槛','随时退'];
                return arr[val];
            },
        },
        // 用来定义子组件
        components: {
            'v-swipe': () => import('../frame/swipe.vue'),
            'v-mapInfo2': () => import('../frame/mapInfo2.vue'),
            'v-comment':() => import('../frame/comment.vue')
        }
    }
</script>

<style lang="scss">
    @import '../../assets/css/px2rem.scss';
    html,body,main,.app-main{
        height:100%;
        background-color: #F6F6F6;
    }
    #discountDetails{
        #swipe{
            .mint-swipe-indicators{
                left:auto;
                right:px2rem(12);
                bottom:px2rem(12);
                .mint-swipe-indicator{
                    height:px2rem(6);
                    width:px2rem(6);
                    opacity: 1;
                    background: #fff;
                }
                .is-active{
                    background: #FF4A2A;
                }
            }
        }
        /*券类信息*/
        .voucherInfo{
            box-sizing: content-box;
            height:px2rem(114);
            padding:px2rem(12);
            padding-bottom: 0;
            background-color: #fff;
            margin-bottom: px2rem(12);
            overflow: hidden;
            .top{
                height:px2rem(71);
                border-bottom: 1px solid #eee;
                h3{
                    font-size: px2rem(18);
                    line-height: px2rem(25);
                    color: #333;
                    margin-bottom: px2rem(4);
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
                p{
                    font-size: px2rem(14);
                    line-height: px2rem(20);
                    color: #666;

                }
            }
            .bottom{
                height:px2rem(29);
                padding-left:px2rem(20);
                padding-top: px2rem(10);
                border-top:1px solid #eee;
                color: #999999;
                font-size: px2rem(14);
                span{
                    position: relative;
                    &::before{
                        content: '';
                        position: absolute;
                        left:px2rem(-20);
                        top:px2rem(2);
                        height:px2rem(16);
                        width:px2rem(16);
                        background: url("../../assets/img/food_gou.png") no-repeat center center;
                        background-size: 100% 100%;
                    }
                }
            }

        }
        /*详情*/
        .details{
            padding:px2rem(12);
            background-color: #fff;
            font-size: px2rem(14);
            margin-bottom: px2rem(12);
            h3{
                color: #999;
                line-height: px2rem(20);
                margin-bottom: px2rem(21);
            }
            ul{
                li{
                    margin-bottom: px2rem(5);
                    p{
                        overflow: hidden;
                        color: #333;
                        /*display: flex;*/
                        /*justify-content:space-between;*/
                        span{
                            display: inline-block;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                        span:nth-child(1){
                            width:px2rem(210);
                        }
                        span:nth-child(2){
                            width:px2rem(60);
                        }
                        span:nth-child(3){
                            text-align: right;
                            width:px2rem(77);
                        }

                    }
                }
            }

        }
        /*使用须知*/
        .notice{
            height:px2rem(314);
            padding:0 px2rem(12) ;
            background-color: #fff;
            margin-bottom: px2rem(12);
            h3{
                font-size: px2rem(14);
                color: #999;
                line-height: px2rem(36);
                border-bottom: px2rem(1) solid #eee;
                margin-bottom: px2rem(12);
            }
            dl{
                dt{
                    font-size: px2rem(14);
                    line-height: px2rem(20);
                    color: #333;
                    font-weight: bold;
                }
                dd{
                    padding-left: px2rem(12);
                    font-size: px2rem(14);
                    line-height: px2rem(28);
                    color: #666;
                }
            }


        }
        i{
            display: block;
            height:px2rem(56);
            width:100%;
            margin-top: px2rem(5);
        }
        .gain{
            position: fixed;
            max-width: 1280px;
            bottom:0;
            left:0;
            background-color: #fff;
            padding:0 px2rem(12);
            width:100%;
            height:px2rem(56);
            line-height: px2rem(56);
            font-size: px2rem(16);
            color:#fff;
            span{
                font-size: px2rem(28);
                color: #FF4A2A;
            }
            s{
                color: #999;
                padding-left: px2rem(7.5);
            }
            a{
                float: right;
                color:#fff;
                margin-top: px2rem(8);
                width:px2rem(88);
                height:px2rem(40);
                text-align: center;
                line-height: px2rem(40);
                background-image: linear-gradient(-90deg, #FF5B00 0%, #FF413E 100%);
                border-radius: px2rem(4);
            }
        }
    }

</style>
